import { createSelector } from 'reselect';

const getUserPermissionSets = ({ userProfileReducer }) =>
    userProfileReducer.permissionSets;

const getIsUserExpertAdmin = ({ globalReducer }) =>
    globalReducer.isUserExpertAdmin;

const getIsUserExpert = ({ globalReducer }) =>
    globalReducer.isUserAllowedToExpertMode;

const getIsUserTriageAdmin = createSelector(
    [getUserPermissionSets],
    (permissionSets) => permissionSets.includes('Aquant Triage Admin')
);

export const getIsUserExpertOrAdmin = createSelector(
    [getIsUserTriageAdmin, getIsUserExpert, getIsUserExpertAdmin],
    (isUserTriageAdmin, isUserExpert, isUserExpertAdmin) =>
        isUserTriageAdmin || isUserExpert || isUserExpertAdmin
);
